import { get_api_path } from "services/api";
import { store } from "../store";
import { sessioned_client } from "./auth";

export async function list({ query }) {
  const url = get_api_path("product/list", query);
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { models, meta } = response.data.result;
  return { models, meta };
};

export async function detail(product_id) {
  const url = get_api_path("product/detail", {}, { product_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).get(url);
  const { model } = response.data.result;
  return { model };
};

export async function del(product_id) {
  const url = get_api_path("product/delete", {}, { product_id });
  const { token } = store.getState().profile;
  await sessioned_client(token).delete(url);
};

export async function update(product_id, data) {
  const url = get_api_path("product/update", {}, { product_id });
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function create(data) {
  const url = get_api_path("product/create");
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function create_topup(data) {
  data = {
    ...data,
    type: "credit_purchase",
    fulfilment_type: "digital"
  };
  const url = get_api_path("product/create");
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};

export async function create_classpass(data) {
  data = {
    ...data,
    type: "pass_purchase",
    fulfilment_type: "digital"
  };
  const url = get_api_path("product/create");
  const { token } = store.getState().profile;
  const response = await sessioned_client(token).post(url, data);
  const { model } = response.data.result;
  return { model };
};